import './style.scss'
import { AbsoluteContainer, CustomContainer, FixedContainer, GridContainer } from "src/style"
import {ReactComponent as PopupBgImg} from 'src/assets/img/d2-popup-bg-img.svg'
import { CenterPopupHeaderD3 } from 'src/component'

export const AppCenterPopupPlusD3: React.FC<any> = ({
    bgColor, padding, title, height,
    overlayBgColor, className, zIndex, shadow,
    close, back, children, overflow, width, radius, 
    contentHeight, maxHeight, contentTopMargin,
    outerViewHeight, outerViewMaxHeight, outerViewMaxHeightUnit
}) => {

    return (
       <>
            <FixedContainer 
                height='full' width='100' sizeUnit='%' top='0' left='0' 
                zIndex={zIndex || 4}
                className='row-container-popup'
            >
                <GridContainer 
                    width='100' sizeUnit='%' height='100' hUnit='%' 
                    bgColor={overlayBgColor || 'rgba(0,0,0, 0.3)'}
                    onClick={close}
                >
                    <CustomContainer 
                        width={width || '42'} height={height || '54.6'} radius={radius || '2'} 
                        bgColor={bgColor || '#ffffff'} padding={padding || '2'} bottomPadding='2' 
                        overflow={overflow || 'auto'}
                        shadow={shadow || '0px 24px 56px rgba(0, 23, 69, 0.04)'}
                        className={`popup-main-container popup-main-container-d2 ${className}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <AbsoluteContainer top='-2.5' left='0'>
                            <PopupBgImg />
                        </AbsoluteContainer>
                        <CenterPopupHeaderD3 title={title} back={back} close={close}/>
                        <CustomContainer 
                            height={contentHeight || '54'} topMargin={contentTopMargin|| '0'}
                            maxHeight={maxHeight || 100} mxHUnit='%'
                            className="popup-content-container"
                        >
                            {children}
                        </CustomContainer>
                    </CustomContainer>
                </GridContainer>
            </FixedContainer>

            <CustomContainer 
                width='45' sizeUnit='%' radius={radius || '2'} 
                bgColor={bgColor || '#ffffff'}
                padding={padding || '2'} bottomPadding='2' topPadding='1'
                overflow={overflow || 'auto'}
                height={outerViewHeight || null} 
                maxHeight={outerViewMaxHeight || null}
                mxHUnit={outerViewMaxHeightUnit || null}
                className='row-container'
            >
                {children}
            </CustomContainer>
       </>
    )
}